
	import LoginForm from "@/components/login/LoginForm.vue";
	import RecoverPasswordForm from "@/components/login/RecoverPasswordForm.vue";
	import { Login } from "@/models/login";
	import mixins from "vue-typed-mixins";
	import Session from "@/shared/mixins/Session";
	import Language from "@/shared/mixins/Language";
	const MIXINS = [Session, Language];
	const Vue = mixins(...MIXINS);

	export default Vue.extend({
		components: { LoginForm, RecoverPasswordForm },
		name: "Login",
		mixins: MIXINS,
		data() {
			return {
				/**
				 * Renders login form when true otherwise renders password reset form.
				 **/
				isLogin: true,
				/**
				 * Shows spinner when logging in.
				 **/
				loading: false,
				errorMessage: "",
				errorMessageStatus: false,
				languages: [
					{
						id: 1,
						locale: "en",
						text: "English",
					},
					{
						id: 2,
						locale: "es",
						text: "Español",
					},
					{
						id: 3,
						locale: "ja",
						text: "日本語",
					},
				],
				currentLanguage: this.getLocale || "es",
			};
		},
		mounted: function () {
			this.currentLanguage = this.getLocale;
			this.changeLocale();
			let elHtml = document.getElementsByTagName("html")[0];
			elHtml.style.overflowY = "hidden";
		},
		destroyed: function () {
			let elHtml = document.getElementsByTagName("html")[0];
			elHtml.style.overflowY = "";
		},
		methods: {
			checkLogin() {
				// eslint-disable-next-line
				const form: any = this.$refs.form;
				if (form) {
					form.login();
				}
			},
			async doLogin(loginForm: Login) {
				this.errorMessageStatus = false;
				this.loading = true;
				this.login(loginForm)
					.then(() => {
						this.loading = false;
					})
					.catch((err) => {
						if (err.response.status) {
							this.errorMessage = this.$t(
								"errors.login." + err.response.status
							).toString();
							this.errorMessageStatus = true;
							setTimeout(() => {
								this.errorMessageStatus = false;
							}, 5000);
						}
						this.loading = false;
					});
			},
			toLoginForm() {
				this.isLogin = true;
			},
			recoveryPassword() {
				// eslint-disable-next-line
				const form: any = this.$refs.recoveryForm;
				if (form) {
					form.toRecoveryPassword();
				}
			},
			/**
			 * Sends an email for password reset.
			 * @public
			 */
			sendReset() {
				console.log("Reset password");
			},
			toRecoveryPasswordForm() {
				this.isLogin = false;
			},
			changeLocale() {
				if (this.currentLanguage) {
					this.$i18n.locale = this.currentLanguage;
					this.clearLoginForm();
					this.clearPasswordRecoverForm();
				}
			},
			clearLoginForm() {
				// eslint-disable-next-line
				const form: any = this.$refs.form;
				if (form) {
					form.reset();
				}
			},
			clearPasswordRecoverForm() {
				// eslint-disable-next-line
				const form: any = this.$refs.recoveryForm;
				if (form) {
					form.reset();
				}
			},
		},
		computed: {
			windowSize() {
				return { x: window.innerWidth, y: window.innerHeight };
			},
		},
	});
